/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.contactShort,
            url: '/' + 'Contactgegevens',
            cache: false,
            title: 'Uw gegevens',
            headerTitle: 'Uw gegevens',
            configuratorStepName: ['ContactStep'],
            order: 6,
            operations: ['SetContactDetails'],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/contactShort.html',
                    controller: Controllers.ContactShortController.controllerId + ' as vm'
                }
            },
            showInMenu: true
        }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }

    App.Core.appCore.run(appRun);
}